import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DateRangeSelector from '../../../components/DateRangeSelector/DateRangeSelector';
import { Box, Flex } from '@chakra-ui/react';
import { Transaction } from '../../../domain/transaction';
import TransactionDonutChart from './TransactionDonutChart';
import useDashboardDonutFilterDate from '../hook/useDashboardDonutFilterDate';
import SalesNet from './SalesNet';
import {DashboardTransacFiltersQueryParams} from "../hook/useDashboardTransactionFilters";
import {useTransactionDonutChartData} from "../hook/useTransactionDonutChartData";

interface DateRangeProps {
  startDate: Date | null, endDate: Date | null;
}

const DashboardDonutChart = ({ queryParams }: {queryParams: DashboardTransacFiltersQueryParams}) => {
  const {transactionsByDate, filterBy} = useDashboardDonutFilterDate(queryParams)

  const [dateRange, setDateRange] = useState<DateRangeProps>({startDate: null, endDate: null})
  const transactionsByFilterDate: Transaction[] = useMemo(() => transactionsByDate, [transactionsByDate])

  const {
    donutCharts,
    statSalesNet
  } = useTransactionDonutChartData(transactionsByFilterDate)

  const handleDateRangeChange = useCallback((startDate: Date|null, endDate: Date|null) => {
    if(startDate && endDate) {
      setDateRange({startDate, endDate})
    }
  }, []);

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      filterBy(dateRange.startDate, dateRange.endDate)
    }
  }, [dateRange]);

  return <>
    <Box p="xl" borderWidth="1px" borderRadius="lg" width="full">
      <Flex width="auto" mb={1}>
        <DateRangeSelector onDateRangeChange={handleDateRangeChange}/>
      </Flex>
      <SalesNet salesNetModel={statSalesNet} />
      <TransactionDonutChart data={donutCharts} transactionSize={transactionsByFilterDate.length}/>
    </Box>

  </>
}

export default DashboardDonutChart
